export default {
    roles: [],
    users: [],
};
